import { Component } from "@theme/component";
import { MediaStartedPlayingEvent } from "@theme/events";

class TiktokPopupContent extends Component {
  constructor() {
    super();
    this.loadContent = this.loadContent.bind(this);
  }

  connectedCallback() {
    this.dialog = this.closest("dialog-component");
    if (!this.dialog) return;

    this.dialog.addEventListener("dialog:open", this.loadContent);
  }

  async loadContent() {
    if (this.getAttribute("data-media-loaded")) return;

    this.dispatchEvent(new MediaStartedPlayingEvent(this));

    const tiktokUrl = this.getAttribute("data-tiktok-url");
    if (!tiktokUrl) {
      console.error("No TikTok URL provided");
      return;
    }

    try {
      // Fetch embed code from TikTok oEmbed API
      const oembedUrl = `https://www.tiktok.com/oembed?url=${encodeURIComponent(
        tiktokUrl
      )}`;
      const response = await fetch(oembedUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch TikTok embed: ${response.statusText}`);
      }

      const data = await response.json();

      if (!data.html) {
        throw new Error("No embed HTML returned from TikTok API");
      }

      // Create a temporary container to parse the HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data.html;

      // Get the blockquote element
      const embedContent = tempDiv.querySelector("blockquote");

      if (!embedContent) {
        throw new Error("Invalid embed HTML structure");
      }

      // Insert the embed content into the popup
      const innerContainer = this.querySelector(".tiktok-popup__inner");
      if (innerContainer) {
        innerContainer.appendChild(embedContent);
      }

      this.setAttribute("data-media-loaded", "true");

      // Load TikTok embed script if not already loaded
      if (
        !document.querySelector('script[src="https://www.tiktok.com/embed.js"]')
      ) {
        const tiktokScript = document.createElement("script");
        tiktokScript.src = "https://www.tiktok.com/embed.js";
        tiktokScript.async = true;
        document.body.appendChild(tiktokScript);
      } else {
        // If script is already loaded, manually trigger the embed rendering
        // @ts-expect-error - TikTok embed script adds tiktok object to window
        if (window.tiktok && typeof window.tiktok.embed === "function") {
          // @ts-expect-error - TikTok embed script adds tiktok object to window
          window.tiktok.embed();
        }
      }
    } catch (error) {
      console.error("Error loading TikTok embed:", error);

      // Show error message to user
      const innerContainer = this.querySelector(".tiktok-popup__inner");
      if (innerContainer) {
        innerContainer.innerHTML = `
          <div style="padding: 2rem; text-align: center;">
            <p>Unable to load TikTok video. Please check the URL and try again.</p>
          </div>
        `;
      }
    }
  }
}

if (!customElements.get("tiktok-popup-content")) {
  customElements.define("tiktok-popup-content", TiktokPopupContent);
}
